import { FILTER, GENERAL } from "api/ApiPath";
import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import apiConfig from "api/client";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { OverviewServiceItem } from "./model/OverviewServiceResponseModel";
import { TransactionDetailReportRequestModel } from "./model/TransactionDetailReportRequestModel";
import { TransactionDetailReportItem } from "./model/TransactionDetailReportResponseModel";
import { TransactionReportRequestModel } from "./model/TransactionReportRequestModel";
import { TransactionReportItem } from "./model/TransactionReportResponseModel";
import { GeneralResponseModel } from "./models/GeneralResponseModel";

export interface IGeneralRepository {
  getGeneralData(): Promise<BaseApiResponseModel<GeneralResponseModel[]>>;
  getTransactionReport(
    params: TransactionReportRequestModel
  ): Promise<BaseApiResponseModel<TransactionReportItem[]>>;
  getTransactionDetailReport(
    params: TransactionDetailReportRequestModel
  ): Promise<BaseApiResponseModel<TransactionDetailReportItem[]>>;
  exportTransactionDetailReport(
    params: TransactionDetailReportRequestModel & { store?: string; staff?: string }
  ): Promise<BaseApiResponseModel<Blob>>;
  getOverviewServiceList(): Promise<
    BaseApiResponseModel<OverviewServiceItem[]>
  >;
};

@injectable()
export class GeneralImpl implements IGeneralRepository {
  async getGeneralData(): Promise<
    BaseApiResponseModel<GeneralResponseModel[]>
  > {
    return await apiConfig.get(GENERAL.GENERAL_DATA);
  }

  async getTransactionReport(
    params: TransactionReportRequestModel
  ): Promise<BaseApiResponseModel<TransactionReportItem[]>> {
    return await apiConfig.get(GENERAL.TRANSACTION_REPORT, params as any);
  }

  async getTransactionDetailReport(
    params: TransactionDetailReportRequestModel
  ): Promise<BaseApiResponseModel<TransactionDetailReportItem[]>> {
    return await apiConfig.get(
      GENERAL.TRANSACTION_DETAIL_REPORT,
      params as any
    );
  }

  async exportTransactionDetailReport(
    params: TransactionDetailReportRequestModel & { store?: string; staff?: string }
  ): Promise<BaseApiResponseModel<Blob>> {
    const queryString = new URLSearchParams(params as any).toString();
    const url = `${GENERAL.TRANSACTION_DETAIL_REPORT}?${queryString}`;
    const token = DataFormat.getToken();
    const alterToken = DataFormat.getAlterToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token ? token : alterToken}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to export report: ${response.statusText}`);
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }

  async getOverviewServiceList(): Promise<
    BaseApiResponseModel<OverviewServiceItem[]>
  > {
    return await apiConfig.get(FILTER.OVERVIEW_SERVICE);
  }
}

export const defaultGeneralRepository: IGeneralRepository = new GeneralImpl();
